export default "__VITE_ASSET__cbc2tSCu__"